import { createContext, useContext, useEffect, useState } from "react";
import axios from 'axios';
import getBaseUrl from "../../utils/apiUrl";

const ApiProfile = createContext({});

export function useApiProfile() {
    return useContext(ApiProfile);
}

export function ProfileApiProvider({ children }) {
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("token");

    async function getData(token) {
        const url = getBaseUrl + "/api/profile/detail";
        setLoading(true);
        try {
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // console.log(response.data.data.id)
            setProfileData(response.data.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getData(token);
    }, []);

    // 🔹 Perbaikan di sini:
    const contextValue = {
        profileData,
        setProfileData,
        loading,
        setLoading,
        getData, // ← tambahkan ini!
    };

    return (
        <ApiProfile.Provider value={contextValue}>
            {children}
        </ApiProfile.Provider>
    );
}
